import { Button, Chip, Divider } from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import dynamic from "next/dynamic";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import { fbClient } from "../lib/facebook";

const data = {
  series: [
    {
      name: "New Campaigns",
      data: [10, 18, 13, 24, 20, 30],
    },
  ],
  options: {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      show: false,
      // row: {
      //   colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      //   opacity: 0.5,
      // },
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      categories: ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov"],
      tooltip: {
        enabled: false,
      },
    },
    tooltip: {
      x: {
        show: false,
      },
    },
    legend: {
      show: true,
      showForSingleSeries: true,
    },
  },
};

export default function Home() {
  const Chart = dynamic(() => import("react-apexcharts"), { ssr: false });

  const handleClick = async () => {
    const params = {
      fields: "name",
    };

    const res = await fbClient
      .get(`act_1034940083776988`, { params })
      .catch((err) => console.log(err.response.data));
    console.log(res);
  };

  return (
    <div className="">
      <div className="h-[425px]px-5">
        <div className=" max-w-4xl mx-auto py-2">
          <h1 className="text-3xl mb-2">Dashboard</h1>
          <Chip
            icon={<StoreOutlinedIcon />}
            label="3 business"
            onClick={() => {}}
            sx={{ px: 1 }}
          />
          <div className="space-y-5 mt-16">
            <h1 className="text-xl opacity-80">Metrics</h1>
            <div className="bg-bone rounded-lg px-5 py-2 text-gray-500">
              <Button startIcon={<CampaignIcon />} onClick={handleClick}>
                Campaigns
              </Button>
              <div className="flex">
                <div className="text-sm flex-1 justify-center flex flex-col">
                  <h1 className="">
                    Campaigns <span className="font-light">(current)</span>
                  </h1>
                  <h1 className="text-2xl text-gray-800">
                    {data.series[0].data.reduce((c, n) => c + n)}{" "}
                    <span className="text-sm text-gray-500">+268.7%</span>
                  </h1>
                </div>
                <div className="flex-1">
                  <Chart
                    options={data.options}
                    series={data.series}
                    type="line"
                    height={125}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-10 max-w-4xl mx-auto">
        <Divider />
      </div>
    </div>
  );
}
